module.exports = __webpack_public_path__ + "img/40_38_057_050.815a8940.jpg";